let csss = require('./index.css')
let template = require('./index.html')
module.exports = Dialog

let default_options = {
  body: '',
  width: 380,
  height: 0,
  maskclose: true,
  onclose: null,
  onshow: null
}

let $body = $(document.body)
function disabledMouseWheel() {
  function scrollFunc(evt) {
    return false;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFunc, false);
  }//W3C
  window.onmousewheel = document.onmousewheel = scrollFunc;//IE/Opera/Chrome
}
function ableMouseWheel() {
  function scrollFuncRecover (evt){
    return true;
  }
  if (document.addEventListener) {
    document.addEventListener('DOMMouseScroll', scrollFuncRecover, false);
  }//W3C
  window.onmousewheel = document.onmousewheel = scrollFuncRecover;//IE/Opera/Chrome
}
function Dialog(opts) {
  if (!(this instanceof Dialog)) return new Dialog(opts);
  this.opts = $.extend({}, default_options, opts);
  this._createElement();
  this._initEvents();
}

Dialog.prototype = {

  show: function () {
    let self = this,
      opts = self.opts,
      $el = self.$el,
      $box = self.$box;
    $box.css({
      'width': opts.width,
      'margin-left': -opts.width / 2
    })
    $el.show()

    let h = opts.height > 0 ? opts.height : $box.height()
    self.$box.css({
      'height': h,
      'top': -h / 2,
      'margin-top': -h / 2
    })
    disabledMouseWheel();
    setTimeout(function () {
      self.$el.addClass('active')
    }, 0);
    opts.onshow && opts.onshow();
    return self
  },

  close: function () {ableMouseWheel();
    let self = this,
      opts = self.opts
    self.$el.removeClass('active')
    self.$box.hide()
    setTimeout(function () {
      self.$el.hide()
      setTimeout(function () {
        self._destroy()
      }, 500);
    }, 350);
    opts.onclose && opts.onclose();
    return self
  },

  on: function () {
    var self = this,
      $el = self.$el;
    $el.on.apply($el, Array.prototype.slice.call(arguments))
    return self
  },

  find: function (selector) {
    return this.$box.find(selector)
  },

  _destroy: function () {
    this.$el.remove()
    this.$el = null
    this.$box = null
  },

  _initEvents: function () {
    let self = this
    self.opts.maskclose && self.$el.on('click', 'div.pcqb-dialog-mask', function (e) {
      self.close()
    });
    self.$el.on('click', '.submit', function (e) {
      self.close()
      self.opts.onclose && self.opts.onclose();
    });
    self.$el.on('click', '.close', function (e) {
      self.close()
    });
    self.$el.on('click', '.addres', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
      lottery.getUserContact();//todo 耦合性太高
    });
  },

  _createElement: function () {
    let $el = $(template({
      body: this.opts.body
    }));
    this.$el = $el
    this.$box = $el.find('div.dialog-wrap')
    $body.append($el)
  }

}



// WEBPACK FOOTER //
// ./components/dialog/index.js